import React, { useState, useContext } from "react";
import PropTypes from "prop-types";
import { useMsal } from "@azure/msal-react";
import { Box } from "@mui/system";
import { Typography, Popover } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import HandshakeIcon from "../../../../../../assets/icons/HandshakeIcon";
import CarrierNetworkManuallyAddStatus from "../../CarrierNetworkManuallyAddStatus/CarrierNetworkManuallyAddStatus";
import CarrierNetworkActionBase from "../CarrierNetworkActionBase/CarrierNetworkActionBase";
import { CarrierService } from "../../../../../../services/CarrierService";
import { AlertContext } from "../../../../../Dashboard/Dashboard";

export default function CarrierNetworkRelationshipAction({ 
  networkUserName, 
  networkUserId,
  activeUser,
  networkStatus,
  getNetworkStatus,
  carrier,
  getCarrier,
  canUpdate,
  canRemove,
  statusLabels,
  carrierNetworkId,
  setIsLoading,
  setIsUpdating,
  canAddManually,
  userDefault
}) {
  const { instance } = useMsal();
  const { warning } = useContext(AlertContext);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const pid = open ? "carrier-network-relationship-actions-popover" : undefined;

  const handleRemove = () => {
    const payload = {
      userId: activeUser.userIdMcld,
      carrierNetworkId: carrierNetworkId,
      carrierId: carrier.id
    };

    setIsLoading(true);
    setIsUpdating(true);

    CarrierService.RemoveCarrierRelationship(instance, payload).then(() => {
      getNetworkStatus();
      getCarrier();
      setIsUpdating(false);
    }).catch(error => {
      console.error(error);
      setIsUpdating(false);
      getNetworkStatus();
      warning(error);
    });
  }; 

  return (
    <>
      <CarrierNetworkActionBase
        backgroundColor="purple.60"
        canUpdate={canUpdate}
        canAddManually={canAddManually}
        onClick={(e) => (canAddManually || canUpdate) && setAnchorEl(e.currentTarget)}
      >
        <HandshakeIcon sx={{ fontSize: "20px" }} />
        <Typography variant="h4" sx={{ padding: "0 4px" }}>
          {networkUserName}
        </Typography>
        {(canAddManually || canUpdate) &&
          <KeyboardArrowDownIcon sx={{ fontSize: "20px" }} />
        }
      </CarrierNetworkActionBase>
      <Popover
        id={pid}
        open={open}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        slotProps={{
          paper: {
            sx: { boxShadow: "elevation3" },
          }
        }}
      >
        { canAddManually
          ? <CarrierNetworkManuallyAddStatus
            networkUserId={networkUserId}
            cancel={setAnchorEl}
            networkStatus={networkStatus}
            getNetworkStatus={getNetworkStatus}
            carrier={carrier}
            networkUser={userDefault}
            getCarrier={getCarrier}
          />
          : <Box sx={{ padding: "12px 0" }}>
            {canRemove &&
                <Box
                  onClick={handleRemove}
                  sx={{ padding: "10px 30px 10px 20px", "&:hover": { cursor: "pointer", backgroundColor: "black_solid.10" } }}
                >
                  <Typography variant="subhead2" color="black_solid.80">
                      Remove {statusLabels[networkStatus]}
                  </Typography>
                </Box>
            }
          </Box>
        }
      </Popover>
    </>
  );
}

CarrierNetworkRelationshipAction.propTypes = {
  networkUserName: PropTypes.string,
  networkStatus: PropTypes.string.isRequired,
  statusLabels: PropTypes.object.isRequired,
  canUpdate: PropTypes.bool,
  canRemove: PropTypes.bool,
  setIsLoading: PropTypes.func,
  getNetworkStatus: PropTypes.func.isRequired,
  carrier: PropTypes.object.isRequired,
  activeUser: PropTypes.object,
  networkUserId: PropTypes.string,
  carrierNetworkId: PropTypes.number,
  getCarrier: PropTypes.func.isRequired,
  setIsUpdating: PropTypes.func.isRequired,
  canAddManually: PropTypes.bool.isRequired,
  userDefault: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ])
};